import noop from 'lodash/fp/noop';
import { ZigzagHandler } from '../';
import { isBrowser } from '../../../utils/conditions';

export const initialHandlers: ZigzagHandler = {
  onBookmarkStatus: noop,
  onKakaoLinkAvailable: noop,
  onSavedProductStatus: noop,
  onUserAccount: noop,
  onAppNotificationStatus: noop,
  onStatusbarHeight: noop,
  onSavedShopList: noop,
  onProductReviewListFilter: noop,
  onSavedMyGoods: noop,
};

export const injectZigzagHandler = <A>(args?: A) => {
  if (!isBrowser()) {
    return console.warn('Should invoke injectZigzagHandler in client');
  }

  const _window: any = window;
  if (!_window.zigzagHandler) {
    _window.zigzagHandler = initialHandlers;
  }
  return args;
};
